import requestUtil from './requestUtil';

export const loadSettings = async ({lang, ns}) => {
    return new Promise(resolve => {
        requestUtil(`/S7WContentService/api/v1/content/settings?lang=${lang}&ns=${ns}`)
            .then((data) => {
                resolve(data);
            });
    });
};